import waja from 'waja';

const cities = {};

const callbacks = {};

function loadCityFromApi (zipCode) {
	waja.get('city/zip/' + zipCode)
		.on('success', res => {
			const city = res.data.city;
			cities[zipCode] = city;
			for (const cb of callbacks[zipCode] || []) {
				cb(city);
			}
			delete callbacks[zipCode];
		}).go();
}

// Hämta namn på en postort utan att ladda in två gånger
// @TODO skriv och använd någon cachemodul (som synkas över alla flikar)
export default function (zip, callback) {
	if (zip in cities) {
		callback(cities[zip]);
		return;
	}
	if (! (zip in callbacks)) {
		callbacks[zip] = [];
		callbacks[zip].push(callback);
		loadCityFromApi(zip);
	} else {
		callbacks[zip].push(callback);
	}
}
